// import { FilelogInfo, WorkgroupLogInfo } from 'src/api/adminApi';
// import { WorkspaceDTO } from 'src/store/workspace';

import dayjs from "dayjs";
import utilsCommon from "./common";

const workspaceUtil = {
  getStorageTotal: (workspaceDetail: any): number => {
    if (workspaceDetail.paymentCode === "DEFAULT") {
      return 500 * 1024 * 1024;
    } else {
      return (
        (workspaceDetail.maxUserCount +
          workspaceDetail.maxUserCount *
            workspaceDetail.planInfo.externalUserPerUser) *
        workspaceDetail.planInfo.storagePerUser *
        1024 *
        1024
      );
    }
  },
  isAvailableAnotherWebOffice: (types: any): boolean => {
    for (const key in types) {
      if (types[key] === true) {
        return true;
      }
    }

    return false;
  },
  convertConfigEditor: (value: string): string => {
    let returnValue = "";
    switch (value) {
      case "ALL":
        if (workspaceUtil.getLanguage() === "ko") {
          returnValue = "모두 사용";
        } else {
          returnValue = "Use (All users)";
        }
        break;
      case "INTERNAL_USER":
        if (workspaceUtil.getLanguage() === "ko") {
          returnValue = "내부 사용자만 사용";
        } else {
          returnValue = "Use (internal users only)";
        }
        break;
      case "DENY":
        if (workspaceUtil.getLanguage() === "ko") {
          returnValue = "사용 안 함";
        } else {
          returnValue = "Not in use";
        }
        break;
    }
    return returnValue;
  },
  validationCompanyName: (companyName: string): boolean => {
    const regex = /^([a-zA-Z0-9가-힣ㄱ-ㅎㅏ-ㅣ!@#$%()[\]_-]{0,30})$/;
    return regex.test(companyName);
  },
  ipRegx: (num: string): boolean => {
    const regNum =
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return regNum.test(num);
  },
  getDateFormatCal: (): string => {
    const locale = workspaceUtil.getLanguage() === "ko" ? false : true;
    let dateFormat = "yyyy-MM-dd";

    if (locale === true) {
      dateFormat = "MMM dd, yyyy";
    } else {
      dateFormat = "yyyy-MM-dd";
    }
    return dateFormat;
  },
  calcIpAddress: (arr: any): number => {
    return arr.reduce((accum: string, currVal: string, index: number) => {
      let calcValue = 0;
      const setNumber = Number(currVal);
      switch (index) {
        case 1:
          calcValue = setNumber * 16777216;
          break;
        case 2:
          calcValue = setNumber * 65536;
          break;
        case 3:
          calcValue = setNumber * 256;
          break;
        case 4:
          calcValue = setNumber * 1;
          break;
      }

      return Number(accum + calcValue);
    });
  },

  validationIpBand: (ipFromStr: string, ipToStr: string): boolean => {
    /*
      1. ip 대역 범위 체크
      2. ip 유효성 체크
    */
    if (ipFromStr === "" && ipToStr === "") {
      return false;
    } else if (
      (ipFromStr !== "" && ipToStr === "") ||
      (ipFromStr === "" && ipToStr !== "")
    ) {
      return false;
    } else if (
      workspaceUtil.ipRegx(ipFromStr) === false ||
      workspaceUtil.ipRegx(ipToStr) === false
    ) {
      return false;
    } else {
      const from = workspaceUtil.calcIpAddress(ipFromStr.split("."));
      const to = workspaceUtil.calcIpAddress(ipToStr.split("."));
      return from <= to;
    }
  },
  getLanguage: (): string => {
    return window.navigator.language === "ko" ||
      window.navigator.language === "ko-KR" ||
      window.navigator.language === "ko-kr"
      ? "ko"
      : window.navigator.language === "en" ||
        window.navigator.language === "en-US" ||
        window.navigator.language === "en-us"
      ? "en"
      : window.navigator.language === "ko-KR" ||
        window.navigator.language === "ko-kr"
      ? "ko"
      : "en";
  },
  convertConfigUnWrapping: (value: string): string => {
    let returnValue = "";
    switch (value) {
      case "ALL":
        if (workspaceUtil.getLanguage() === "ko") {
          returnValue = "모두 허용";
        } else {
          returnValue = "All";
        }
        break;
      case "INTERNAL_USER":
        if (workspaceUtil.getLanguage() === "ko") {
          returnValue = "내부 사용자만 허용";
        } else {
          returnValue = "Allow only internal users";
        }
        break;
      case "MASTER":
        if (workspaceUtil.getLanguage() === "ko") {
          returnValue = "파일 관리자만 허용";
        } else {
          returnValue = "Allow only File Manager";
        }
        break;
    }
    return returnValue;
  },
  convertConfigWebOfficeType: (value?: string | null): string => {
    let returnValue = "";
    switch (value) {
      case "OOS":
        returnValue = "OOS";
        break;
      case "OFFICE365":
        returnValue = "Office 365";
        break;
      case "THINKFREE":
        returnValue = "ThinkFree";
        break;
      case "COLLABORA":
        returnValue = "Collabora";
        break;
      case "Office 365":
        returnValue = "OFFICE365";
        break;
      case "ThinkFree":
        returnValue = "THINKFREE";
        break;
      case "Collabora":
        returnValue = "COLLABORA";
        break;
      default:
        returnValue = "";
        break;
    }
    return returnValue;
  },
  isAvailableWebOffice: (types: any, value?: string | null): boolean => {
    let returnValue = false;

    switch (value) {
      case "OOS":
        if (types.oosUse) {
          returnValue = true;
        }
        break;
      case "OFFICE365":
        if (types.office365Use) {
          returnValue = true;
        }
        break;
      case "THINKFREE":
        if (types.tfsiUse) {
          returnValue = true;
        }
        break;
      case "COLLABORA":
        if (types.collaboraUse) {
          returnValue = true;
        }
        break;
      default:
        break;
    }
    return returnValue;
  },
  convertConfigUser: (value: string): string => {
    let returnValue = "";
    switch (value) {
      case "ALL":
        if (workspaceUtil.getLanguage() === "ko") {
          returnValue = "모든 사용자에게 표시";
        } else {
          returnValue = "Show to all users";
        }
        break;
      case "MY_LIST":
        if (workspaceUtil.getLanguage() === "ko") {
          returnValue = "초대한 사용자에게만 표시";
        } else {
          returnValue = "Show to invited users";
        }
        break;
    }
    return returnValue;
  },
  getNameWithId: (name?: string, id?: string): string => {
    if (name) {
      return name + "(" + id + ")";
    } else if (id) {
      return id;
    } else {
      return "알 수 없는 사용자";
    }
  } /*
  작업 내용 툴팁 속 내용
  1. 워크그룹 사용자 추가 툴팁
  2. 워크그룹 탈퇴 툴팁
  3. 워크그룹 장 변경 툴팁
  4. 워크그룹 권한 변경에 대한 툴팁
  5. 사용자 파일 권한 변경 툴팁
  6. 워크그룹 사용차 초대 툴팁
 */,
  // 1. 워크그룹 사용자 추가 툴팁
  getAddMemberContent: (log: any): React.ReactNode => {
    const desc = log.desc;
    const invitee =
      log.desc !== "" ? desc.substr(desc.lastIndexOf(" ") + 1) : log.userName;
    let invitees = "";
    log.logDatas &&
      log.logDatas.map((item: any, index: number) =>
        index === log.logDatas.length - 1
          ? (invitees += item)
          : (invitees += item + ", ")
      );
    return (
      <div className="content">
        <div className="content_header">
          <div className="bluedot" />
          <div className="userInfo">{invitee}</div>
        </div>
      </div>
    );
  },
  // 2. 워크그룹 탈퇴 툴팁
  getDeleteMemberContent: (log: any) => {
    const desc = log.desc ? log.desc : "";
    let deletee =
      log.desc !== "" ? desc.substr(desc.lastIndexOf(" ") + 1) : log.userName;
    let deletees = "";
    log.logDatas &&
      log.logDatas.map((item: any, index: number) =>
        index === log.logDatas.length - 1
          ? (deletees += item)
          : (deletees += item + ", ")
      );
    if (deletees !== "") deletee = deletees;
    return (
      <div className="content">
        <div className="content_header">
          <div className="bluedot" />
          <div className="userInfo">{deletee}</div>
        </div>
      </div>
    );
  },
  // 3. 워크그룹 장 변경 툴팁
  getchangeHeadContent: (log: any) => {
    const desc = log.desc ? log.desc : "";
    const index = desc.indexOf(" -> ");
    const oldHead = desc.substr(0, index);
    const newHead = desc.substr(index + 4);
    return (
      <div className="content">
        <div className="content_header">
          <div className="bluedot" />
          <div className="userInfo">{newHead}</div>
        </div>
        <div className="content_body">
          <div className="line">
            <svg
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 4.5L4.5 7.5L11 1"
                stroke={
                  window.eco.companyName === "workspace" ? "#b79dff" : "#30c56e"
                }
              />
            </svg>
            <div className="line_body">
              {workspaceUtil.getLanguage() === "ko"
                ? "기존: " + oldHead
                : "Default: " + oldHead}
            </div>
          </div>
        </div>
      </div>
    );
  },
  // 4. 워크그룹 권한 변경에 대한 툴팁
  getWorkgroupPolicyContent: (log: any) => {
    if (!log.policyLogs) return;
    const policy = log.policyLogs[0]?.permissionPolicy.policy;

    return (
      <div className="content">
        <div className="content_body">
          <div className="line-withoutSpace">
            <svg
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 4.5L4.5 7.5L11 1"
                stroke={
                  window.eco.companyName === "workspace" ? "#b79dff" : "#30c56e"
                }
              />
            </svg>
            <div className="line-withoutSpace_body">
              {workspaceUtil.getLanguage() === "ko"
                ? policy.revision
                  ? "파일 편집"
                  : "파일 열람"
                : policy.revision
                ? "Edit File"
                : "Read File"}
            </div>
          </div>
          {policy.download && (
            <div className="line">
              <svg
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 4.5L4.5 7.5L11 1"
                  stroke={
                    window.eco.companyName === "workspace"
                      ? "#b79dff"
                      : "#30c56e"
                  }
                />
              </svg>
              <div className="line_body">
                {workspaceUtil.getLanguage() === "ko"
                  ? "파일 다운로드"
                  : "File Download"}
              </div>
            </div>
          )}
          {policy.drmPerm.length > 0 && (
            <div className="line-advanced">
              <svg
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 4.5L4.5 7.5L11 1"
                  stroke={
                    window.eco.companyName === "workspace"
                      ? "#b79dff"
                      : "#30c56e"
                  }
                />
              </svg>
              <div className="line-advanced_body">
                {workspaceUtil.getLanguage() === "ko"
                  ? "보안 강화"
                  : "Enhanced security"}
              </div>
            </div>
          )}
          {policy.drmPerm.length > 0 && (
            <div className="line-advanced_body-advanced">
              <div>
                {policy.drmPerm && policy.drmPerm.includes("print")
                  ? workspaceUtil.getLanguage() === "ko"
                    ? "· 인쇄"
                    : "· Print"
                  : ""}
              </div>

              <div>
                {policy.drmPerm && policy.drmPerm.includes("print_screen")
                  ? workspaceUtil.getLanguage() === "ko"
                    ? "· 화면 캡처"
                    : "· Screenshot"
                  : ""}
              </div>

              <div>
                {policy.drmPerm && policy.drmPerm.includes("extract")
                  ? workspaceUtil.getLanguage() === "ko"
                    ? "· 문서 내용 복사"
                    : "· Copy Document Contents"
                  : ""}
              </div>
            </div>
          )}
          {policy.webView && (
            <div className="line">
              <svg
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 4.5L4.5 7.5L11 1"
                  stroke={
                    window.eco.companyName === "workspace"
                      ? "#b79dff"
                      : "#30c56e"
                  }
                />
              </svg>
              <div className="line_body">
                {workspaceUtil.getLanguage() === "ko"
                  ? "웹 사용"
                  : "Support Website"}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  },
  // 5-0. 사용자 파일 권한 변경 툴팁
  getPolicyTooltip: (policy: any, title: string) => {
    return (
      <div className="content">
        <div className="content_header">
          <div className="bluedot" />
          <div className="userInfo">{policy.title}</div>
        </div>
        <div className="content_body">
          <div className="line">
            <svg
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 4.5L4.5 7.5L11 1"
                stroke={
                  window.eco.companyName === "workspace" ? "#b79dff" : "#30c56e"
                }
              />
            </svg>
            <div className="line_body">{title}</div>
          </div>
        </div>
      </div>
    );
  },
  getDateFormat: (): string => {
    const locale = workspaceUtil.getLanguage() === "ko" ? false : true;
    let dateFormat = "YYYY-MM-DD";

    if (locale === true) {
      dateFormat = "MMM DD, YYYY";
    } else {
      dateFormat = "YYYY-MM-DD";
    }
    return dateFormat;
  },
  getDateShortStr: (timestamp: number): string => {
    const locale = workspaceUtil.getLanguage() === "ko" ? false : true;
    let dateFormat = "YYYY-MM-DD";

    if (locale === true) {
      dateFormat = "MMM DD, YYYY";
    } else {
      dateFormat = "YYYY-MM-DD";
    }
    return dayjs(timestamp).format(dateFormat);
  },
  // 5. 사용자 파일 권한 변경 툴팁
  getAdvancedPolicyContent: (log: any | any) => {
    const simpleTimeZone = new Map([
      [-11, { con: "Pacific/Midway", str: "-11:00" }],
      [-10, { con: "Pacific/Pago_Pago", str: "-10:00" }],
      [-9, { con: "etc/gmt-9", str: "-9:00" }],
      [-8, { con: "America/Anchorage", str: "-8:00" }],
      [-7, { con: "America/Vancouver", str: "-7:00" }],
      [-6, { con: "America/Denver", str: "-6:00" }],
      [-5, { con: "America/Chicago", str: "-5:00" }],
      [-4, { con: "America/New_York", str: "-4:00" }],
      [-3, { con: "America/Halifax", str: "-3:00" }],
      [-2.5, { con: "America/St_Johns", str: "-2:30" }],
      [-2, { con: "America/Godthab", str: "-2:00" }],
      [-1, { con: "Atlantic/Cape_Verde", str: "-1:00" }],
      [0, { con: "Etc/Greenwich", str: "+0:00" }],
      [1, { con: "Europe/Dublin", str: "+1:00" }],
      [2, { con: "Europe/Belgrade", str: "+2:00" }],
      [3, { con: "Europe/Helsinki", str: "+3:00" }],
      [4, { con: "Asia/Dubai", str: "+4:00" }],
      [5, { con: "Asia/Yekaterinburg", str: "+5:00" }],
      [5.5, { con: "Asia/Calcutta", str: "+5:30" }],
      [5.75, { con: "Asia/Kathmandu", str: "+5:45" }],
      [6, { con: "Asia/Almaty", str: "+6:00" }],
      [6.5, { con: "Asia/Rangoon", str: "+6:30" }],
      [7, { con: "Asia/Krasnoyarsk", str: "+7:00" }],
      [8, { con: "Asia/Shanghai", str: "+8:00" }],
      [9, { con: "Asia/Seoul", str: "+9:00" }],
      [9.5, { con: "Australia/Darwin", str: "+9:30" }],
      [10, { con: "Asia/Vladivostok", str: "+10:00" }],
      [11, { con: "Asia/Magadan", str: "+11:00" }],
      [12, { con: "Asia/Kamchatka", str: "+12:00" }],
      [13, { con: "Pacific/Apia", str: "+13:00" }],
    ]);
    return log.policyLogs ? (
      log.policyLogs.map((policy: any, index: number) => {
        return (
          <div className="content" key={index}>
            {index === 0 && (
              <div className="content_file">
                <div className="line_body">
                  {workspaceUtil.getLanguage() === "ko"
                    ? "파일: " + log.documnetName
                    : "File: " + log.documnetName}
                </div>
              </div>
            )}
            {policy.permissionPolicy.uniqueId === "MASTER" ? (
              workspaceUtil.getPolicyTooltip(
                policy,
                workspaceUtil.getLanguage() === "ko"
                  ? "관리자 권한"
                  : "Administrator rights"
              )
            ) : policy.permissionPolicy.authType === "DENY" ? (
              workspaceUtil.getPolicyTooltip(
                policy,
                workspaceUtil.getLanguage() === "ko" ? "권한 없음" : "No Rights"
              )
            ) : policy.permissionPolicy.changeCode === "DELETE" &&
              policy.permissionPolicy.policyType === "DOCUMENT" ? (
              workspaceUtil.getPolicyTooltip(
                policy,
                workspaceUtil.getLanguage() === "ko"
                  ? "사용자 개별 권한"
                  : "User Individual Rights"
              )
            ) : (
              <div>
                <div className="content_header">
                  <div className="bluedot" />
                  <div className="userInfo">{policy.title}</div>
                </div>
                <div className="content_body">
                  <div className="line">
                    <svg
                      width="12"
                      height="9"
                      viewBox="0 0 12 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 4.5L4.5 7.5L11 1"
                        stroke={
                          window.eco.companyName === "workspace"
                            ? "#b79dff"
                            : "#30c56e"
                        }
                      />
                    </svg>
                    <div className="line_body">
                      {workspaceUtil.getLanguage() === "ko"
                        ? policy.permissionPolicy.policy.revision
                          ? "파일 편집"
                          : "파일 열람"
                        : policy.permissionPolicy.policy.revision
                        ? "Edit File"
                        : "Read File"}
                    </div>
                  </div>
                  {policy.permissionPolicy.policy.download && (
                    <div className="line">
                      <svg
                        width="12"
                        height="9"
                        viewBox="0 0 12 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 4.5L4.5 7.5L11 1"
                          stroke={
                            window.eco.companyName === "workspace"
                              ? "#b79dff"
                              : "#30c56e"
                          }
                        />
                      </svg>
                      <div className="line_body">
                        {workspaceUtil.getLanguage() === "ko"
                          ? "파일 다운로드"
                          : "File Download"}
                      </div>
                    </div>
                  )}
                  {policy.permissionPolicy.policy.drmPerm &&
                    policy.permissionPolicy.policy.drmPerm.length > 0 && (
                      <div className="line-advanced">
                        <svg
                          width="12"
                          height="9"
                          viewBox="0 0 12 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 4.5L4.5 7.5L11 1"
                            stroke={
                              window.eco.companyName === "workspace"
                                ? "#b79dff"
                                : "#30c56e"
                            }
                          />
                        </svg>
                        <div className="line-advanced_body">
                          {workspaceUtil.getLanguage() === "ko"
                            ? "보안 강화"
                            : "Enhanced security"}
                        </div>
                      </div>
                    )}
                  {policy.permissionPolicy.policy.drmPerm &&
                    policy.permissionPolicy.policy.drmPerm.length > 0 && (
                      <div className="line-advanced_body-advanced">
                        <div>
                          {policy.permissionPolicy.policy.drmPerm &&
                          policy.permissionPolicy.policy.drmPerm.includes(
                            "print"
                          )
                            ? workspaceUtil.getLanguage() === "ko"
                              ? "·  인쇄"
                              : "· Print"
                            : ""}
                        </div>
                        <div>
                          {policy.permissionPolicy.policy.drmPerm &&
                          policy.permissionPolicy.policy.drmPerm.includes(
                            "print_screen"
                          )
                            ? workspaceUtil.getLanguage() === "ko"
                              ? "· 화면 캡처"
                              : "· Screenshot"
                            : ""}
                        </div>
                        <div>
                          {policy.permissionPolicy.policy.drmPerm &&
                          policy.permissionPolicy.policy.drmPerm.includes(
                            "extract"
                          )
                            ? workspaceUtil.getLanguage() === "ko"
                              ? "· 문서 내용 복사"
                              : "· Copy Document Contents"
                            : ""}
                        </div>
                        {policy.permissionPolicy.policy.allowViewCount > 0 &&
                          (workspaceUtil.getLanguage() === "ko" ? (
                            <div>
                              {"· 남은 열람 "}
                              {policy.permissionPolicy.policy.allowViewCount -
                                policy.permissionPolicy.policy
                                  .currentViewCount <=
                              0
                                ? 0
                                : policy.permissionPolicy.policy
                                    .allowViewCount -
                                  policy.permissionPolicy.policy
                                    .currentViewCount}
                              {"(전체 " +
                                policy.permissionPolicy.policy.allowViewCount +
                                "회)"}
                            </div>
                          ) : (
                            <div>
                              {"· Remaining view count "}
                              {policy.permissionPolicy.policy.allowViewCount -
                                policy.permissionPolicy.policy
                                  .currentViewCount <=
                              0
                                ? 0
                                : policy.permissionPolicy.policy
                                    .allowViewCount -
                                  policy.permissionPolicy.policy
                                    .currentViewCount}
                              {"(Total " +
                                policy.permissionPolicy.policy.allowViewCount +
                                ")"}
                            </div>
                          ))}
                        {policy.permissionPolicy.policy.allowDays > 0 &&
                          policy.permissionPolicy.policy.startTime > 0 && (
                            <div>
                              {workspaceUtil.getLanguage() === "ko"
                                ? "· 열람 기간"
                                : "· Inspection Period"}
                              {"(GMT" +
                                simpleTimeZone.get(
                                  policy.permissionPolicy.policy
                                    .allowDaysTimeZone &&
                                    policy.permissionPolicy.policy
                                      .allowDaysTimeZone !== 0
                                    ? policy.permissionPolicy.policy
                                        .allowDaysTimeZone
                                    : 9
                                )?.str +
                                ") "}
                              {policy &&
                              policy.permissionPolicy.policy.allowDays > 0
                                ? dayjs(
                                    policy.permissionPolicy.policy.startTime
                                  )
                                    .add(
                                      policy.permissionPolicy.policy.allowDays -
                                        1,
                                      "d"
                                    )
                                    .tz("Asia/Seoul")
                                    .format(workspaceUtil.getDateFormat())
                                : workspaceUtil.getLanguage() === "ko"
                                ? "무제한"
                                : "Unlimited"}
                            </div>
                          )}
                      </div>
                    )}
                  {policy.permissionPolicy.policy.webView && (
                    <div className="line">
                      <svg
                        width="12"
                        height="9"
                        viewBox="0 0 12 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 4.5L4.5 7.5L11 1"
                          stroke={
                            window.eco.companyName === "workspace"
                              ? "#b79dff"
                              : "#30c56e"
                          }
                        />
                      </svg>
                      <div className="line_body">
                        {workspaceUtil.getLanguage() === "ko"
                          ? "웹 사용"
                          : "Web Support"}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      })
    ) : log.logDatas && log.logDatas[0] ? (
      <div className="content">
        <div className="content_file">
          <div className="line_body">
            {workspaceUtil.getLanguage() === "ko"
              ? "파일: " + log.documnetName
              : "File: " + log.documnetName}
          </div>
        </div>
        <div className="content_header">
          <div className="bluedot" />
          <div className="userInfo">{log.logDatas[0]}</div>
        </div>
      </div>
    ) : (
      ""
    );
  },
  getPolicyContent: (log: any) => {
    let returnStr;
    const saveType = log.saveType;
    const actionType = log.actionType;
    const historyType = log.historyType;
    switch (saveType) {
      case 0:
        if (actionType === "deleted") {
          if (workspaceUtil.getLanguage() === "ko") {
            returnStr = "워크그룹 영구 삭제";
          } else {
            returnStr = "Delete Workgroup Completely";
          }
        } else if (actionType === "restore") {
          if (workspaceUtil.getLanguage() === "ko") {
            returnStr = "워크그룹 복원";
          } else {
            returnStr = "Recover Workgroup";
          }
        } else if (actionType === "delete") {
          if (workspaceUtil.getLanguage() === "ko") {
            returnStr = "워크그룹 삭제";
          } else {
            returnStr = "Delete Workgroup";
          }
        } else if (actionType === "add") {
          if (workspaceUtil.getLanguage() === "ko") {
            returnStr = "워크그룹 생성";
          } else {
            returnStr = "Create Workgroup";
          }
        }
        break;
      case 1:
        returnStr = log.desc;
        break;
      case 2:
        returnStr = workspaceUtil.getWorkgroupPolicyContent(log);
        break;
      case 3:
        if (actionType === "succession")
          returnStr = workspaceUtil.getchangeHeadContent(log);
        break;
      case 4:
        if (actionType === "withdraw")
          returnStr = returnStr = workspaceUtil.getDeleteMemberContent(log);
        else if (actionType === "delete")
          returnStr = returnStr = workspaceUtil.getDeleteMemberContent(log);
        else if (actionType === "invite")
          returnStr = workspaceUtil.getAddMemberContent(log);
        else if (actionType === "add" || actionType === "change")
          returnStr = workspaceUtil.getAddMemberContent(log);
        break;
      case 9:
        if (historyType === 1) {
          returnStr = workspaceUtil.getAdvancedPolicyContent(log);
        }
        break;
      default:
        break;
    }
    return returnStr;
  },
  getPathVariable: (index: number): string => {
    const indexHost =
      window.location.href.indexOf(window.location.host) +
      window.location.host.length +
      1;
    return window.location.href.substring(indexHost).split("/")[index] ?? "";
  },
  getStoragePercentage: (total?: number, current?: number): string => {
    if (!current || !total) return "0";
    const result = Math.floor((current / (total * 1024 * 1024 * 1024)) * 100);
    return result === 0 && current > 0 ? "1" : result + "";
  },
  checkMySpace: () => {
    return (
      window.eco.serviceType === "OCI" &&
      utilsCommon.getWorkspaceCode() === "MTECOCOMMON00001"
    );
  },
};

export default workspaceUtil;
